import React, { Component } from 'react';
import { BackHandler } from 'react-native';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import Utility from '../../utils/Utility';
import List from '../List/List';
import { fetchList } from '../../actions/ActionTypes';
import withNavigation from '../../utils/WithNavigation';
import { ScreenPlaceholder } from '../../components/shared';
import FilterUtils, { canOpenSortingModal } from '../../components/sort-filter-options/FilterUtils';
import { isPresent } from '../../utils/BooleanUtility';
import { debounce } from '../../utils/LodashUtility';
import Config from '../../libraries/ReactNativeConfig';

class ListTabPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: {},
      isLoading: false,
      listPage: 0,
      isRefreshing: false,
      error: null,
      selectedFilters: {},
      filters: [],
      quickFilters: [],
      filteredSlug: '',
      showProductShimmer: false,
      hideOosProduct: false,
      stickyPosition: 0,
    };

    this.slug = props.listSlug;
    this.pageNo = 0;
    this.quickFiltersRef = null;
    this.prevAppliedFiltersFromModal = [];
    this.selectedQuickFilters = [];
    this.fnAutoListPaginationRef = null;
    this.initializeBackHandler();
    this.debouncedFetchFilteredList = debounce(this.fetchFilteredList.bind(this), 1000);
  }

  componentDidMount() {
    this.fetchListData();
  }

  componentWillUnmount() {
    this.removeBackHandler();
  }

  componentWillUpdate(prevProps) {
    const {
      cartPrompts,
    } = this.props;
    if (Config.REWARDS_PAGE_ROUTE === 'ListTab2' && JSON.stringify(prevProps.cartPrompts) !== JSON.stringify(cartPrompts)) {
      this.fetchListData();
    }
  }

  initializeBackHandler = () => {
    if (Utility.isAndroid()) {
      this.backHandler = BackHandler.addEventListener('hardwareBackPress', this.handleBackPress);
    }
  };

  removeBackHandler = () => {
    if (Utility.isAndroid() && this.backHandler) {
      this.backHandler.remove();
    }
  };

  handleBackPress = () => {
    const { navigation } = this.props;
    navigation.navigate('Feed');
    return true;
  };

  fetchListData = () => {
    const { fetchList } = this.props;
    this.setState({ isLoading: true, error: null });
    fetchList({ slug: this.slug }, this.pageNo, this.handleFetchResponse);
  };

  handleFetchResponse = (success, data) => {
    if (success) {
      const { list: objects, position: stickyPosition, slug } = Utility.createFilterObjectIfExists(
        data?.objects || [],
        true,
        false,
        true,
      );
      this.slug = slug;
      if (isPresent(objects)) {
        const updatedData = { ...data, objects };
        const { filters, quickFilters } = FilterUtils.getFiltersFromList(updatedData);
        this.setState({
          itemData: updatedData,
          isLoading: false,
          error: null,
          filters,
          quickFilters,
          stickyPosition,
        });
      } else {
        this.setState({
          itemData: data,
          isLoading: false,
          error: null,
          filters: [],
          quickFilters: [],
        });
      }
    } else {
      this.setState({
        isLoading: false,
        error: 'Failed to fetch list data',
      });
    }
  };

  onFiltersPress = (item, added, index, resetQuickFilter, hideOosProductParam = this.state.hideOosProduct) => {
    const { navigation } = this.props;
    const { itemData, selectedFilters, filters } = this.state;
    const { list: productList } = FilterUtils.getList(itemData);
    const shouldOpenSortingModal = canOpenSortingModal(item, selectedFilters);
    if (shouldOpenSortingModal) {
      navigation.navigate('SortingFilteringModal', {
        selectedFilters,
        modalFilters: filters,
        onFilterApplyPress: this.onFiltersPress,
        listName: itemData?.name || '',
        listId: itemData?.id || '',
        listSlug: this.slug,
        listData: itemData,
        screenName: SCREEN_CONSTANTS.LIST_TAB,
        entityName: itemData?.name || '',
        showFoxyMatchModal: item.criteria_name === 'quick_filter_foxy_match',
        hideOosProduct: hideOosProductParam,
        onPressHideOosCheckBox: this.onPressHideOosCheckBox,
        resetQuickFilter,
      });
      return;
    }

    const {
      slug,
      pageNo,
      allowNextPageLoad,
      groupedSelectedFilters,
      selectedQuickFilters: newSelectedQuickFilters,
      prevAppliedFiltersFromModal: newPrevAppliedFilters,
    } = FilterUtils.onFilterApplied(
      item,
      added,
      index,
      productList,
      selectedFilters,
      this.quickFiltersRef,
      this.slug || '',
      this.prevAppliedFiltersFromModal,
      this.selectedQuickFilters,
      SCREEN_CONSTANTS.LIST_TAB,
      itemData?.name || '',
      hideOosProductParam,
    );

    this.slug = slug;
    this.pageNo = pageNo;
    this.allowNextPageLoad = allowNextPageLoad;
    this.selectedQuickFilters = newSelectedQuickFilters;
    this.prevAppliedFiltersFromModal = newPrevAppliedFilters;

    const updatedItemData = {
      ...itemData,
      list: { ...itemData, objects: Utility.addShimmerInListObject(itemData) },
    };
    this.setState({
      selectedFilters: groupedSelectedFilters,
      filteredSlug: slug,
      itemData: updatedItemData,
      showProductShimmer: true,
    });
    if (slug) {
      this.debouncedFetchFilteredList(slug, hideOosProductParam);
    }
  };

  fetchFilteredList = (slug, hideOosProduct) => {
    const { fetchList } = this.props;
    this.slug = slug;
    fetchList({ slug: this.slug, hideOosProduct }, this.pageNo, (success, data) => {
      if (!success) {
        this.setState({
          isLoading: false,
          showProductShimmer: false,
          error: 'Failed to fetch filtered list',
        });
        return;
      }

      const updatedListData = FilterUtils.appendFilteredListToMasterListObjects(slug, data, this.state?.itemData);

      this.setState({
        itemData: { ...updatedListData },
        isLoading: false,
        showProductShimmer: false,
      });
    });
  };

  onPressHideOosCheckBox = (isHideOos) => {
    this.setState({ hideOosProduct: isHideOos });
  };

  resetFilters = () => {
    const { listSlug } = this.props;
    this.pageNo = 0;
    this.quickFiltersRef?.resetQuickFilters();
    this.selectedQuickFilters = [];
    this.prevAppliedFiltersFromModal = [];

    this.setState({
      selectedFilters: {},
      filteredSlug: '',
      showProductShimmer: false,
      isLoading: false,
    });

    this.slug = listSlug;
    this.fetchListData();
  };

  setListPaginatedCallApiRef = (fnAutoListPagination) => {
    this.fnAutoListPaginationRef = fnAutoListPagination;
  };

  render() {
    const { navigation } = this.props;
    const {
      itemData,
      isLoading,
      error,
      selectedFilters,
      filteredSlug,
      filters,
      quickFilters,
      showProductShimmer,
      hideOosProduct,
      stickyPosition,
    } = this.state;

    if (isLoading) {
      return <ScreenPlaceholder />;
    }

    return (
      <List
        navigation={navigation}
        previousScreen={SCREEN_CONSTANTS.LIST_TAB}
        itemData={itemData}
        selectedFilters={selectedFilters}
        onFiltersPress={this.onFiltersPress}
        filteredSlug={filteredSlug}
        filters={filters}
        quickFilters={quickFilters}
        hideOosProduct={hideOosProduct}
        setListPaginatedCallApiRef={this.setListPaginatedCallApiRef}
        onPressResetButton={this.resetFilters}
        stickyPosition={stickyPosition}
        onRefresh={this.resetFilters}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  cartPrompts: state.bag.cartPrompts,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ fetchList }, dispatch),
});

export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(ListTabPage));